import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { getZodType } from '@next-adapter/generators/form/zod-schema/get-zod-type.js'

export function buildZodFields(flatFields: SchemaField[]): string {
  return flatFields
    .filter((f) => !f.primaryKey && f.type !== 'tabs' && !isLayoutField(f.type))
    .flatMap((f) => {
      const defs: string[] = []
      const zodType = getZodType(f)
      const alreadyOptional = zodType.includes('.optional()')
      let def = `  ${quotePropertyName(f.name)}: ${zodType}`
      if (!f.required && !alreadyOptional) def += '.optional()'
      defs.push(def)
      if (f.hasIcon) defs.push(`  ${quotePropertyName(`${f.name}Icon`)}: z.string().optional()`)
      return defs
    })
    .join(',\n')
}
